<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region
     (image + title + description + CTA together), matching v1's single
     right-side-container click area, unlike Main Banner (image-only content). -->
<div class="cr-pd-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-pd-badge">Property Description</span>

  <div
    class="cr-pd-dropzone"
    [appInlineMedia]="currentDeviceImage"
    [inlineMediaBlockId]="block.blockId"
    (inlineMediaChange)="onChange($event, currentDeviceImageKey)"
  >
    <a *ngIf="currentDeviceImage; else emptyPreview" [href]="imagePreviewHref" target="_blank" rel="noopener">
      <img [src]="currentDeviceImage" [alt]="block.variables?.['PropertyDescImageAlt'] || ''" />
    </a>

    <ng-template #emptyPreview>
      <div class="cr-inline-media-icon">
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-inline-media-title">Upload image</div>
      <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
    </ng-template>
  </div>

  <span
    class="cr-pd-name"
    [appInlineEdit]="block.variables?.PropertyDescPropertyName ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property name"
    (inlineEditChange)="onChange($event, 'PropertyDescPropertyName')"
  ></span>

  <span
    class="cr-pd-desc"
    [appInlineEdit]="block.variables?.PropertyDescription ?? ''"
    [inlineEditBlockId]="block.blockId"
    inlineEditPlaceholder="Insert property description"
    [inlineEditMultiline]="true"
    (inlineEditChange)="onChange($event, 'PropertyDescription')"
  ></span>

  <a class="cr-pd-cta" [href]="ctaPreviewHref" target="_blank" rel="noopener">
    <span
      [appInlineEdit]="block.variables?.PropertyDescCtaText ?? ''"
      [inlineEditBlockId]="block.blockId"
      [inlineEditPlaceholder]="ctaButtonPlaceholder"
      (inlineEditChange)="onChange($event, 'PropertyDescCtaText')"
    ></span>
  </a>
</div>

<!-- Right panel: real edit form -->
<div class="cr-pd-edit" *ngIf="!isPreview">
  <div class="cr-pd-field-row">
    <span class="cr-pd-field-label">Desktop Image</span>
    <span
      class="cr-pd-toggle"
      [class.cr-pd-toggle-on]="desktopImageAsUpload"
      role="button"
      tabindex="0"
      [title]="desktopImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleDesktopImageMode()"
      (keydown.enter)="toggleDesktopImageMode()"
      (keydown.space)="toggleDesktopImageMode()"
    ></span>
  </div>
  <div class="cr-pd-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyDescImageDesktop'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyDescImageDesktop')"
      [placeholder]="imageDesktopPlaceholder"
      variable="PropertyDescImageDesktop"
      [isImage]="desktopImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-pd-empty-overlay" *ngIf="desktopImageAsUpload && !block.variables?.['PropertyDescImageDesktop']">
      <div class="cr-pd-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-pd-title">Upload image</div>
      <div class="cr-pd-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-pd-field-row">
    <span class="cr-pd-field-label">Mobile Image</span>
    <span
      class="cr-pd-toggle"
      [class.cr-pd-toggle-on]="mobileImageAsUpload"
      role="button"
      tabindex="0"
      [title]="mobileImageAsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
      (click)="toggleMobileImageMode()"
      (keydown.enter)="toggleMobileImageMode()"
      (keydown.space)="toggleMobileImageMode()"
    ></span>
  </div>
  <div class="cr-pd-image-field">
    <app-block-text
      [maxLength]="500"
      type="link"
      [blockData]="block.variables?.['PropertyDescImageMobile'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyDescImageMobile')"
      [placeholder]="imageMobilePlaceholder"
      variable="PropertyDescImageMobile"
      [isImage]="mobileImageAsUpload"
      [isPlainText]="true"
      [blockId]="block.blockId"
    ></app-block-text>
    <div class="cr-pd-empty-overlay" *ngIf="mobileImageAsUpload && !block.variables?.['PropertyDescImageMobile']">
      <div class="cr-pd-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
          <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
          <path d="M12 19.2V11.7" />
          <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
        </svg>
      </div>
      <div class="cr-pd-title">Upload image</div>
      <div class="cr-pd-subtitle">PNG up to 2 mb</div>
    </div>
  </div>

  <div class="cr-pd-link-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="action-link"
      [blockData]="block.variables?.['PropertyDescImageHref'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyDescImageHref')"
      [placeholder]="imageHrefPlaceholder"
      variable="PropertyDescImageHref"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyDescImageHrefSegmentRegex')"
      [selectedSegment]="block.variables?.['PropertyDescImageHrefSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-pd-alt-field">
    <app-field-editor-v2
      [maxLength]="500"
      type="alt"
      [blockData]="block.variables?.['PropertyDescImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyDescImageAlt')"
      [placeholder]="imageAltPlaceholder"
      variable="PropertyDescImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyDescPropertyName'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyDescPropertyName')"
    [placeholder]="namePlaceholder"
    [maxLength]="500"
    variable="PropertyDescPropertyName"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <app-field-editor-v2
    type="content"
    [multiline]="true"
    [showCounter]="true"
    [blockData]="block.variables?.['PropertyDescription'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyDescription')"
    [placeholder]="descriptionPlaceholder"
    [maxLength]="4000"
    variable="PropertyDescription"
    [disabled]="disabled"
  ></app-field-editor-v2>

  <div class="cr-pd-link-field">
    <app-field-editor-v2
      type="action-link"
      [blockData]="block.variables?.['PropertyDescCtaLink'] ?? ''"
      (handleOnChange)="onChange($event, 'PropertyDescCtaLink')"
      [placeholder]="ctaLinkPlaceholder"
      [maxLength]="500"
      variable="PropertyDescCtaLink"
      (handleOnSegmentChange)="handleOnSegmentChange($event, 'PropertyDescCtaLinkSegmentRegex')"
      [selectedSegment]="block.variables?.['PropertyDescCtaLinkSegmentRegex'] ?? ''"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <app-field-editor-v2
    type="content"
    [blockData]="block.variables?.['PropertyDescCtaText'] ?? ''"
    (handleOnChange)="onChange($event, 'PropertyDescCtaText')"
    [placeholder]="ctaTextPlaceholder"
    [maxLength]="30"
    variable="PropertyDescCtaText"
    [disabled]="disabled"
  ></app-field-editor-v2>
</div>
